module.exports = __webpack_public_path__ + "img/高通锐化3.648ff15a.png";